import React, { useEffect, type AbstractComponent } from 'react'
import {
	NotificationDiv,
	ImgWrapper,
	NotificationSpan,
} from './sharedNotificationStyles'
import {
	NOTIFICATION_TEXT,
	BASIC_NOTIFICATION_LENGTH,
	NOTIFICATION_IMAGE,
} from './constants'

import type { Notification } from './constants'

type Props = {
	notificationObject: Notification,
}
function BasicNotification(
	{ notificationObject }: Props,
	ref: any
): React$Node {
	useEffect(() => {
		const timerId = setTimeout(
			notificationObject.onEnd,
			BASIC_NOTIFICATION_LENGTH
		)
		return () => clearTimeout(timerId)
	}, [notificationObject.onEnd, notificationObject.value])
	let notificationText = NOTIFICATION_TEXT[notificationObject.type]
	const type = notificationObject.type

	return (
		<NotificationDiv ref={ref}>
			<NotificationSpan>{notificationText}</NotificationSpan>
			<ImgWrapper>{NOTIFICATION_IMAGE[type]}</ImgWrapper>
		</NotificationDiv>
	)
}

export default (React.forwardRef(BasicNotification): AbstractComponent<
	Props,
	HTMLDivElement
>)
